<template>
  <div>
    <header >
        <symbol id="icon-cart" viewBox="0 0 38 32">
          <title></title>
        </symbol>
        <div class="el-header">
          <!-- <div class="navbar-left-container" > -->
          <div style="    min-width: 1200px !important;width: 1200px;margin: 0 auto;">
              <!-- <div style="margin-left: 18.75%;margin-top: 0px;" >  -->
              <div  >
                <img src="../../static/images/logo.png" class="header-logo-css" @click="openGoodsList"/>
              </div>
                  <div class="navbar-right-container" style="    display: flex;float: right;margin-top: -55px;">
                    <div class="navbar-menu-container">
                      <span></span>
                      <div class="header-cart-div" @click="toCart" >
                        <!-- <el-badge :value="cartCount" class="item"> -->
                        <img src="../../static/images/购物车.png"/>
                        <!-- </el-badge> -->
                        <span v-if="cartCount >0" class="navbar-cart-count" style="top: -5px;right: -10px;">{{cartCount}}</span>
                      </div>
                    <div>
                        <!--购物车显示块-->
                      <span class="header-Mycart-css"  @click="toCart">我的购物车</span>
                      <span class="header-cartLine-css" ></span>
                      <span class="header-Myoder-css"  @click="myOrder">我的订单</span>
                      <span class="header-orderLine-css" ></span>
                      <!-- <img class="header-photoImg-css" slot="reference"  id="avatarId" :src="logoUrl !=''?logoUrl:'../../static/images/28X28.png'" > -->
                     <!--鼠标移入头像时 显示用户信息 -->
                      <el-popover trigger="hover" ref="popover1" placement="bottom" :disabled="isPopover"  v-model="visible">
                        <div >
                          <p class="header-name" >{{userName}}</p>
                          <p class="header-userName" >{{phone}}</p>
                          <span class="header-userName-line" ></span>
                          <div class="logout" @mouseover="changeIndex(1)" @mouseout="changeIndexBack(1)" >
                            <img :src="indexCenter1" class="header-logout-img"  @click="logout()" />
                            <span class="header-logout-font"  @click="logout()">退出登录</span>
                           </div>
                        </div>
                        <span slot="reference">
                         <img class="header-photoImg-css"  slot="reference" id="avatarId" :src="logoUrl =='/mallApi' || logoUrl =='/mallApidata:image/jpeg;base64,'?'../../static/images/28X28.png':logoUrl" >
                        <span class="header-lan-name"   slot="reference">{{userName}}</span>
                        </span>
                      </el-popover>
                      <!-- 鼠标移入用户名时 显示用户信息-->

                    </div>
                  </div>
                </div>
            </div>
        </div>
      </header>
  </div>
</template>

<script>
import axios from 'axios'
import "../assets/css/icomoon/style.css"
import { mapState } from 'vuex'
export default {
 props: {
    // 默认多选 可选择radio
    totals: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userName: '',
      logoUrl: '',
      phone:"",
      isPopover:true,
      cartCount:this.totals,
      indexCenter1:'../../static/images/logout.svg',
     indexCenter11:'../../static/images/logout1.svg',
     indexCenter111:'../../static/images/logout.svg',
    }
  },
  watch:{
    totals(val){
      //console.log("watch===:"+val);
      this.cartCount = val;
    }

  },
  created() {

  },
  mounted() {
   debugger
   console.log(this.totals);
    this.queryCartCount();
    this.userName = localStorage.getItem('userName');
    this.logoUrl = "/mallApi"+localStorage.getItem('logoUrl');
    this.phone = localStorage.getItem('phone');
    //this.changeIndexBack(1);
    this.phone?this.isPopover=false:this.isPopover=true;
  },
  computed: {

  },
  methods: {
    queryCartCount() {
        axios.get('/mallApi/mall/shopCart/list',{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
        res = res.data;
        //debugger
        if(res.success) {
          //this.cartCount  = res.result.length;
          //localStorage.setItem('cartCount',res.result.length);
         this.cartCount= res.result.length;
        } else  {
          localStorage.setItem('userName','');
          localStorage.setItem('logoUrl','');
          localStorage.setItem('phone','');
          this.cartCount =0;
        }
      });
    },
    openGoodsList(){
        this.$router.push('/goodsList');
         //window.open("#/cart");
    },
    logout() { // 注销
      axios.defaults.headers ={
        "content-type": "application/json",
        "token": localStorage.getItem("Authorization")
      }
      axios.post('/mallApi/mall/index/logout').then((res) => {
        res = res.data;
        if(res.success) {
          localStorage.setItem('Authorization',"");
          localStorage.setItem('userName',"");
          localStorage.setItem('logoUrl',"");
          localStorage.setItem('phone',"");
          this.$router.push('/login');
        }
      });
    },
    toCart() {
      var that = this;
        axios.get('/mallApi/mall/shopCart/list',{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          //debugger
          res = res.data;
          if(res.success){
            that.$router.push({path: '/cart'});
            //window.open("#/cart");
          }else {
            if(res.code == 401|| res.code == 400) {
              localStorage.setItem('Authorization', "");
              localStorage.setItem('userName', "");
              localStorage.setItem('logoUrl', "");
              localStorage.setItem('phone', "");
              this.$router.push({path: '/login'});
            }else{
              this.$message(res.message);
            }

          }

        });
    },
     changeIndex(index){
        switch(index){
          case 1:
            this.indexCenter1 = this.indexCenter11;
            break;
        }
      },
       changeIndexBack(index){
        switch(index){
          case 1:
            this.indexCenter1 = this.indexCenter111;
            break;
        }
      },
    myOrder(){
        this.$router.push({path: '/orderList'});
        //window.open("#/orderList");
    },
  },
  components: {
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
.header {
    background-color: white !important;
    font-family: "moderat",sans-serif !important;
    font-size: 16px !important;
    width: auto !important;
    height: 60px !important;
    border-bottom: 1px solid #eee !important;
    background: #fff !important;
}
.header {
    position: fixed;
    margin-top: -1px;
    z-index: 999;
}
.el-header {
    min-width: 1200px;
    height: 60px;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.02);
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    padding: 0 0px;
}
    .header-logo-css{
      cursor: pointer;margin-top: 15px;
      width: 173px;
      height: 30px;
    }
    .header-Mycart-css{
       cursor: pointer;
       vertical-align: top;
       margin-top: 40px;
       margin-right: 30px;
      font-size: 14px;
      color: #333333;
    }
    .navbar-menu-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 25px!important;
    }
    .header-Mycart-css:hover{color: #287eff}
    .logout .header-logout-font:hover{color: #287eff}
    .logout .header-logout-img:hover+.header-logout-font{
                color: #287eff
            }
    .header-cartLine-css{
        border-right: 1px solid #eee;
        height: 16px;
        margin-left: 0px;
        vertical-align: top;
         margin-top: 5px;
    }
    .header-Myoder-css{
           margin-left: 30px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    vertical-align: top;
    }
    .header-Myoder-css:hover{color: #287eff}
    .header-orderLine-css{
        border-right: 1px solid #eee;
        height: 16px;
        margin-left: 30px;
        vertical-align: top;
        margin-top: 10px;
    }
    .header-photoImg-css{
        margin-right: 10px;
        margin-left: 30px;
        margin-top: -5px;
        width: 30px;
        height: 30px;
        background: #EEEEEE;
        border-radius: 50%;
    }
    .header-cart-div{
        cursor: pointer;
        position: relative;
        margin-right: 20px;
        margin-top: -8px;
    }

    .header-name{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgb(51, 51, 51);
      line-height: 24px;
      text-align: center;
      color: #333333;
    }
    .header-userName{
        margin-top: 5px;
        margin-left: 0px;
        font-size: 14px;
        font-family: PingFang SC;
        color: rgb(102, 102, 102);
        line-height: 24px;
        text-align: center;
        color: #666666;
    }
    .header-userName-line{
        width: 140px;
        border-bottom: 1px solid #eee;
        height: 1px;
        margin-top: 10px;
        float: right;
        margin-right: 0px;
    }
    .header-logout-img{
        margin-top: 25px;
        margin-left: 25px;
        position: absolute;
        cursor: pointer;
    }
    .header-logout-font{
        margin-top: 25px;
        margin-left: 50px;
        position: absolute;
        cursor: pointer;
    }
    .header-lan-name{
      cursor:pointer;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333;
      vertical-align: top;
    }
    .header-lan-name:hover{ color:#287EFF }
    .el-popover {
        position: absolute;
        background: #FFF;
        min-width: 160px !important;
        height: 120px !important;
        border: 1px solid #EBEEF5;
        padding: 12px;
        z-index: 2000;
        color: #606266;
        line-height: 1.4;
        text-align: justify;
        font-size: 14px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        word-break: break-all;
        top: 50px !important;

    }

    .navbar-cart-count {
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 16px !important;
        height: 16px !important;
        border-radius: 8px;
        color: white;
        background-color: #FF620D !important;
        font-weight: 500;
        text-align: center;
        font-size: 12px;
    }
    .navbar {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 100%;
        height: 70px;
        max-width: 1280px;
        margin: 0 auto;
        /* padding: 5px 20px 10px 20px; */
    }
    .navbar-left-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /* margin-left: 30px; */
    }
    .header
      position:fixed
      margin-top: -1px
      z-index:999
      .navbar

        .navbar-brand-logo
          width:120px
          vertical-align:middle
        .search-btn
        	position:absolute
        	top:15px
        	right:30vw
        	@media (max-width:768px)
        	    right:32vw
        	.el-autocomplete
        		display:inline-block
        		position:relative
        		width:17vw
        		@media (max-width:768px)
        		    width:33vw
        		.el-input
        			position:relative
        			font-size:14px
        			@media (max-width:768px)
        			    font-size:12px
        			.el-input__icon
        				position:absolute
        				width:35px
        				height:100%
        				right:0
        				top:0
        				text-align:center
        				color:#bfcbd9
        				transition:all 0.3s
        .navbar-right-container
          position:relative
          .navbar-user
            &:before
              content:''
              position: absolute
              right:30px
              margin-right:20px
              top: 21px
              width: 20px
              height: 20px

              background-size: 240px 107px
              transition: none
          .nav-user-info
            position: absolute
            z-index: 30
            padding-top: 18px
            //opacity: 0
            //visibility: hidden
            top: 38px
            width: 168px
            transform: translate(-70%)
            left: 38%
            .nav-info-list
              position: relative;
              padding-top: 20px;
              background: #fff;
              border: 1px solid #d6d6d6;
              border-color: rgba(0, 0, 0, 0.08);
              border-radius: 8px;
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
              z-index: 10;
              &:before
                position: absolute
                content: " "

                background-size: 240px 107px
                width: 20px
                height: 8px
                top: -8px
                left: 50%
                transform: translateX(-50%)
              .nav-user-avatar
                div
                  position: relative
                  margin: 0 auto 8px
                  width: 46px
                  height: 46px
                  text-align: center
                  &:before
                    content: ""
                    position: absolute
                    left: 0
                    right: 0
                    top: 0
                    bottom: 0
                    border-radius: 50%
                    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06)
                  .avatar
                    width:100%
                    height:100%
                    border-radius: 50%
                .name
                  margin-bottom: 16px
                  font-size: 12px
                  line-height: 1.5
                  text-align: center
                  color: #757575
              .user-li-style
                text-align: center
                position: relative
                border-top: 1px solid #f5f5f5
                line-height: 44px
                height: 44px
                color: #616161
                font-size: 12px
                &:hover
                  background:#f7f7f7
                a
                  display: block
                  color: #616161
          .navbar-cart-container
            position:relative

            .navbar-cart-link
              vertical-align:middle
              &:before
                content:''
                position: absolute
                right: 0
                top: 1px
                width: 30px
                height: 20px

                background-size: 240px 107px
                background-position: -150px -22px;
                transition: none
            .navbar-cart-count
              top: 0px;
              right: -20px;
            .nav-user-wrapper
              position:absolute
              top: 18px
              right:-30px
              width:360px
              padding-top:18px
              visibility: visible
              opacity: 1
              transition: opacity .15s ease-out
              z-index:99
              .nav-user-list
                position: relative;
                background: #fff;
                border: 1px solid #d6d6d6;
                border-color: rgba(0, 0, 0, 0.08);
                border-radius: 8px;
                box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                z-index: 10;
                &:before
                  content:''
                  position: absolute
                  right:33px

                  background-size: 240px 107px
                  width: 20px
                  height: 8px
                  top: -8px
                  margin-left: -10px
                .full
                  border-radius: 8px;
                  overflow: hidden;
                  .nav-cart-items
                    overflow-x: hidden;
                    overflow-y: auto;
                    @media (max-height:1080px)
                      max-height:620px
                    @media (max-height:900px)
                      max-height:744px
                    @media (max-height:768px)
                      max-height:423px
                    .clearfix
                      &:hover
                        background:#f7f7f7
                      .cart-item
                        height: 120px;
                        width: 100%;
                        overflow: hidden;
                        border-top: 1px solid #f0f0f0;
                        &:first-child
                          border-top:none
                          border-radius: 8px 8px 0 0
                        .cart-item-inner
                          padding: 20px
                          position: relative
                          .item-thumb
                            position: relative
                            float: left
                            width: 80px
                            height: 80px
                            border-radius: 3px
                            img
                              display: block
                              width: 100%
                              height: 100%
                              border-radius: 3px
                              overflow: hidden
                          .item-desc
                            margin-left: 98px
                            display: table
                            width: 205px
                            height: 80px
                            .cart-cell
                              display: table-cell
                              vertical-align: middle
                              h4
                                color: #000
                                width: 185px
                                overflow: hidden
                                word-break: keep-all
                                white-space: nowrap
                                text-overflow: ellipsis
                                font-size: 14px
                                line-height: 16px
                                margin-bottom: 10px
                              h6
                                color: #cacaca
                                font-size: 12px
                                line-height: 14px
                                margin-top: 20px
                                span
                                  display: inline-block
                                  font-weight: 700
                                  color: #cacaca
                                .price-icon
                                  color:#d44d44
                                .price-num
                                  margin-left: 5px
                                  font-size: 14px
                                  color: #d44d44
                                .item-num
                                  margin-left: 10px
                          .del-btn
                            display: block
                            cursor: pointer
                            width: 20px
                            height: 20px

                            background-size: 240px 107px
                            text-indent: -9999em
                          .del
                            display: none
                            overflow: hidden
                            position: absolute
                            right: 20px
                            top: 50%
                            transform: translateY(-50%)
                          .showDel
                            display:block
                  .nav-cart-total
                    box-sizing: content-box
                    position: relative
                    padding: 20px
                    height: 40px
                    background: #fafafa
                    border-top: 1px solid #f0f0f0
                    border-radius: 0 0 8px 8px
                    box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.5), 0 -3px 8px rgba(0, 0, 0, 0.04)
                    background: linear-gradient(#fafafa, #f5f5f5)
                    p
                      margin-bottom: 4px
                      line-height: 16px
                      font-size: 12px
                      color: #c1c1c1
                    h5
                      line-height: 20px
                      font-size: 14px
                      color: #6f6f6f
                      span
                        font-size: 18px
                        color: #de4037
                        display: inline-block
                        font-weight: 700
                        &:first-child
                          font-size: 12px
                          margin-right: 5px
                    h6
                      position: absolute
                      right: 20px
                      top: 20px
                      width: 108px
                      input
                        display: inline-block
                        cursor: pointer
                        text-align: center
                        user-select: none
                        display: inline-block
                        width: 100%
                        height: 100%
                      .main-btn
                        border: 1px solid rgb(209, 67, 74)
                        border-radius: 4px
                        font-size: 12px
                        color: #fff
                        background-color: rgb(209, 67, 74)
                        background-image: linear-gradient(180deg, rgb(209, 67, 74), rgb(209, 67, 74))
                        vertical-align: middle
                .cart-con
                  text-align: center
                  position: relative

                  p
                    padding-top: 190px
                    color: #333333
                    font-size: 16px
      .md-login-modal
        width:480px
        @media (max-width:767px)
          width:85% !important
        .confirm-tips
          @media (max-width:767px)
            padding:40px 10px 30px
          .error-wrap
            @media (max-width:767px)
              position:absolute
              top:10px
          ul
            width:100%
            .regi_form_input
              border-radius:6px
              width:100%
            .check-btn
              position:relative
              text-align: right;
              .auto-login
                position: absolute
                top: 0px
                left: 2px
                color: #999
                .el-checkbox__input
                  cursor: pointer;
                  display: inline-block
                  position: relative
                  white-space: nowrap
                  outline: 0
                  line-height: 1
                .el-checkbox__label
                  font-size: 14px
                  padding-left: 5px
            .acolor
              color:#d1434a
            .register
              padding: 1px 10px 0
              border-right: 1px solid #ccc
        .login-wrap
          @media (max-width:767px)
            margin-top:0px !important
          .btn-login
            border-radius:6px
            height: 40px
            line-height: 40px
            border: 2px solid #db0611
            background: #db0611
            &:hover
              border: 2px solid #d1434a
              background: #d1434a


</style>



// WEBPACK FOOTER //
// header.vue?b8f22d8c